import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputMask } from 'primereact/inputmask';

// Telefon validasyon fonksiyonu
const validatePhone = (phone) => {
    // Telefon numarasından maskeyi temizle
    const cleanPhone = phone?.replace(/[^\d]/g, '') || '';
    // Türkiye telefon numarası: 10 haneli olmalı (5XX XXX XX XX)
    return cleanPhone.length === 10 && cleanPhone.startsWith('5');
};

// Telefon numarasını temizle (başındaki 0'ı kaldır)
const cleanPhoneNumber = (phone) => {
    if (!phone) return '';
    let cleaned = phone.replace(/[^\d]/g, '');
    // Başında 0 varsa kaldır (05XX -> 5XX)
    if (cleaned.startsWith('0')) {
        cleaned = cleaned.substring(1);
    }
    return cleaned;
};

export default function UpdatePhoneDialog({ visible, onHide, onSubmit, currentPhone }) {
    const [phone, setPhone] = useState(cleanPhoneNumber(currentPhone));

    const isValid = validatePhone(phone);

    const handleSubmit = () => {
        if (!isValid) {
            return;
        }
        // Temiz telefon numarasını gönder (sadece rakamlar, başına 0 ekle)
        const cleanPhone = phone?.replace(/[^\d]/g, '') || '';
        onSubmit('0' + cleanPhone);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (isValid) {
                handleSubmit();
            }
        }
    };

    const handleClose = () => {
        onHide();
        setPhone(cleanPhoneNumber(currentPhone));
    };

    return (
        <Dialog
            header="Telefon Değiştir"
            visible={visible}
            style={{ width: '450px' }}
            onHide={handleClose}
            footer={
                <div className="flex justify-content-end gap-2">
                    <Button label="İptal" icon="pi pi-times" severity="secondary" onClick={handleClose} />
                    <Button icon="pi pi-check" label="Kaydet" onClick={handleSubmit} disabled={!isValid} />
                </div>
            }
        >
            <div className="flex flex-column gap-3">
                {/* Telefon Numarası */}
                <div className="p-inputgroup">
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-phone"></i>
                    </span>
                    <span className="p-inputgroup-addon">+90</span>
                    <InputMask
                        mask="(599) 999 99 99"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        onKeyDown={handleKeyDown}
                        onKeyUp={(e) => {
                            if (e.key === 'Enter' && isValid) handleSubmit();
                        }}
                        placeholder="(5XX) XXX XX XX"
                        className="w-full"
                    />
                </div>

                {/* Telefon format bilgisi */}
                <div className="text-sm">
                    <p className="m-0 mb-2 font-semibold">Telefon Numarası Gereksinimleri:</p>
                    <ul className="m-0 pl-4" style={{ listStyle: 'none' }}>
                        <li className={isValid ? 'text-green-500' : 'text-red-500'}>
                            <i className={`pi ${isValid ? 'pi-check' : 'pi-times'} mr-2`}></i>
                            Geçerli bir Türkiye cep telefonu numarası (5XX XXX XX XX)
                        </li>
                    </ul>
                </div>
            </div>
        </Dialog>
    );
}
